import { ComponentType } from '@angular/cdk/portal';
import { FirstLossBonusDialogComponent } from 'src/app/components/client-area/prize-boxes/first-loss-bonus-dialog/first-loss-bonus-dialog.component';
import { LiveEventDialogComponent } from 'src/app/components/client-area/prize-boxes/live-event-dialog/live-event-dialog.component';
import { CashbackTeaserToastComponent } from 'src/app/components/notifications/cashback-teaser-toast/cashback-teaser-toast.component';
import { depositTrx, paymentTrx } from 'src/app/router-translation.labels';

export type PopupNotificationConfig =
  | { kind: 'modal'; component: ComponentType<unknown>; panelClass: string[]; data?: unknown }
  | { kind: 'toast'; text: string; panelClass: string[]; duration: number }
  | { kind: 'toast-component'; component: ComponentType<unknown>; data: Record<string, unknown>; panelClass: string[]; duration?: number };

export const POPUP_NOTIFICATION_REGISTRY: Record<string, PopupNotificationConfig> = {
  firstLossBonus: {
    kind: 'modal',
    component: FirstLossBonusDialogComponent,
    panelClass: ['extra-bonus-dialog-wrapper'],
  },
  secondDepositCashbackTeaser: {
    kind: 'toast',
    text: $localize`:@@second-deposit-cashback-teaser:Do you know about Cashback? Enjoy a weekly return based on your gameplay!`,
    panelClass: ['custom-snackbar'],
    duration: 8000,
  },
  cashbackAcqTeaser: {
    kind: 'toast-component',
    component: CashbackTeaserToastComponent,
    data: {
      title: $localize`:@@cashback-acq-teaser-title:Do you know about the Cashback?`,
      body: $localize`:@@cashback-acq-teaser-body:A % of your losses gets returned every week!`,
      icon: 'assets/images/cashback-teaser.png',
    },
    panelClass: ['cashback-teaser-toast'],
  },
  inactivityBoost: {
    kind: 'modal',
    component: LiveEventDialogComponent,
    panelClass: ['extra-bonus-dialog-wrapper'],
    data: {
      heroSrc: 'assets/gamification/extra-bonus/extra.png',
      title: $localize`:@@inactivity-boost-title:Boosted reload!`,
      body: $localize`:@@inactivity-boost-body:Deposit in the next 20 minutes for a 150% Bonus.`,
      ctaText: $localize`:@@inactivity-boost-cta:More info`,
      ctaRoute: ['', paymentTrx, depositTrx],
    },
  },
};
